module.exports = __webpack_public_path__ + "43025c401d52c251f1b0b944cfd837f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-3.png
// module id = 1508
// module chunks = 0